import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { PrFormService } from '../pr-form.service';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'pr-form',
    templateUrl: './pr-form.component.html',
    styleUrls: ['./pr-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrFormComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() formWithTabs: boolean = false;
  @Input() noSubmitBtn: boolean = false;
  @Input() clazz: string = '';
  @Input() submitLabel: string = 'sauvegarder';
  @Input() tabChanged: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @Output() onSubmit: EventEmitter<any> = new EventEmitter();
  @Output() nextTab: EventEmitter<any> = new EventEmitter();

  isLastTab: boolean;

  constructor(private service: PrFormService) {}

  ngOnInit() {
    if (this.formWithTabs) {
      this.tabChanged.asObservable().subscribe({
        next: isLastTab => {
          this.isLastTab = isLastTab;
        },
      });
    }
  }

  ngOnDestroy(): void {
    if (this.tabChanged && !this.tabChanged.isStopped)
      this.tabChanged.unsubscribe();
  }

  submit() {
    if (this.formWithTabs) {
      if (this.isLastTab) {
        this.onSubmit.emit();
      } else {
        this.nextTab.emit();
      }
    } else {
      this.onSubmit.emit();
    }
  }

  cancel() {
    this.service.close();
  }
}
